var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCross = function SvgCross(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.399 4.399A.85.85 0 1 1 15.6 5.601L11.202 10l4.399 4.399a.85.85 0 1 1-1.202 1.202l-4.4-4.399-4.398 4.399a.85.85 0 1 1-1.202-1.202L8.798 10l-4.4-4.399a.85.85 0 0 1 1.203-1.202L10 8.798l4.399-4.399Z",
    fill: "#666"
  })));
};
export default SvgCross;